import Vue from "vue";
import VueRouter from "vue-router";
import OperatorRegistration from "../components/OperatorRegistration";
import ListingsPage from "../components/ListingsPage";
import CreateListingPage from "../components/CreateListing";
import EditListingPage from "../components/EditListingPage";
import AvailabilityPage from "../components/AvailabilityPage";
import LoginPage from "../components/LoginPage";

Vue.use(VueRouter);

const routes = [
    {
        path: "/signup",
        name: "OperatorRegistration",
        component: OperatorRegistration
    }, {
        path: "/listings",
        name: "ListingsPage",
        component: ListingsPage
    }, {
        path: "/create_listing",
        name: "CreateListingPage",
        component: CreateListingPage
    }, {
        path: "/edit_listing/:id",
        name: "EditListingPage",
        component: EditListingPage
    }, {
        path: "/availability",
        name: "AvailabilityPage",
        component: AvailabilityPage
    }, {
        path: "/",
        name: "LoginPage",
        component: LoginPage
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
